import Source from '!!raw!./App';
import App from './App';

export default {
  name: 'Overlay',
  App,
  Source,
};



// WEBPACK FOOTER //
// ./src/examples/Overlay/index.js